import { render, staticRenderFns } from "./GroupsEvents_DELETE.vue?vue&type=template&id=099f15cf&scoped=true"
import script from "./GroupsEvents_DELETE.vue?vue&type=script&lang=js"
export * from "./GroupsEvents_DELETE.vue?vue&type=script&lang=js"
import style0 from "./GroupsEvents_DELETE.vue?vue&type=style&index=0&id=099f15cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f15cf",
  null
  
)

export default component.exports